import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import GameContainer from './GameContainer.js';
import GameScoredInstructions from './GameScoredInstructions.js';

import SmashItCanvas from '../games/SmashItCanvas';
import MisconfiguredGameWarning from './MisconfiguredGameWarning.js';
import { clientFinalPage } from '../games/StageFinalMessages.js';

const Instructions = (props) => {
	const stage = props.stage.Stage;

	if(stage.smash_images.length < 2) return null;

	const score_ranges = {
		ok:{
			score:'+50',
		},
		superok:{
			score:'+150',
			icon:'ep-star',
		},
		ko:{
			score:'-50',
		},
		superko:{
			score:'-5000',
			icon:'ep-death',
		},
	};

	const _superok_images = stage.smash_images.filter((img) => (img.type == 'superok'));
	const _ok_images = stage.smash_images.filter((img) => (img.type == 'ok'));
	const _superko_images = stage.smash_images.filter((img) => (img.type == 'superko'));
	const _ko_images = stage.smash_images.filter((img) => (img.type == 'ko'));

	const ok_images = [ ..._ok_images, ..._superok_images ];
	const ko_images = [ ..._ko_images, ..._superko_images ];

	return (
		<GameScoredInstructions
			stage={stage}
			ok_images={ok_images}
			ko_images={ko_images}
			score_ranges={score_ranges}
		/>
	)
};

const SmashItClient = ({ stage, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const final_stage = clientFinalPage(stage, props.actual_state);

	return (
		<GameContainer
			{...props}
			stage={final_stage}
			instructions={<Instructions
				stage={stage}
				intl={props.intl}
			/>}
			instructions_placeholder={`<h1>${i18n("Instructions")}</h1><p>${i18n("Tap on as many elements as possible to score points. But be careful, some will take points away!")}</p>`}
			game_type="smashit"
			display_attemps={false}
			auto_start_timer={false}
			display_audio_controls={true}
			instructions_has_border={false}
		>
			{((stage.Stage?.smash_images ?? []).length > 0) ? (
				<SmashItCanvas
					locale={props.locale}
					demo_animations={props.demo_animations}
				/>
			) : (
				<MisconfiguredGameWarning
					message="Create at least 1 element to generate the game"
				/>
			)}
		</GameContainer>
	)
};

export default injectIntl(SmashItClient);